import { createSlice } from '@reduxjs/toolkit'

export const appSlice = createSlice({
  name: 'sidebarShow',
  initialState: true,
  reducers: {
    setSidebarShow: (state) => {
      return !state
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSidebarShow } = appSlice.actions

export default appSlice.reducer
